import { formatDecimalNumber } from '@revenuemarket/utils';

export * from './FormattedMoney';

export interface MoneyProps {
  currency?: string;
  amount: number;
  showZero?: boolean;
  formatZero?: boolean;
}

export const Money = ({ currency, amount, formatZero = false, showZero = false }: MoneyProps) => {
  if (amount === 0) {
    if (formatZero) {
      return '-';
    }
    if (showZero) {
      return <>{formatDecimalNumber(amount)}</>;
    }
    return <></>;
  }

  if (currency == null || currency === 'KRW') {
    return <>{formatDecimalNumber(amount)}</>;
  }

  return (
    <>
      {currency}&nbsp;
      {formatDecimalNumber(amount)}
    </>
  );
};
